import sensors from '@xiaoduo/sensors-mark'

sensors.init({
  server_url: 'https://wangcai.1yangai.com/log/event_tracking',
  // heatmap_url 神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。
  heatmap_url: 'https://static.sensorsdata.cn/sdk/1.14.5/heatmap.min.js',
  heatmap: {
    // 是否开启点击图。default 表示开启，自动采集 $WebClick 事件；'not_collect' 表示关闭
    clickmap: 'default',
    // 是否开启触达注意力图。default 表示开启，自动采集 $WebStay 事件；'not_collect' 表示关闭
    scroll_notice_map: 'default',
  },
  cross_subdomain: false,
  is_track_single_page: true,
  use_client_time: true,
  show_log: false,
  send_type: 'ajax',
  mark: localStorage.getItem('mark'),
})

sensors.registerPage({
  app_id: 'xd001',
})

window.addEventListener('load', () => {
  if (!window.performance || process.env.NODE_ENV === 'development') return
  const { timing } = window.performance
  sensors.track('performance', {
    // 白屏时间
    blank_time: timing.domContentLoadedEventEnd - timing.fetchStart,
    // 首屏时间
    index_time: timing.domComplete - timing.fetchStart,
  })
})

export function trackSensors() {
  sensors.quick('autoTrack')
}

export function loginSensors(user) {
  const {
    data: {
      platform = 'tb',
      user_info: { username },
      company_info: { shot_name },
    },
  } = user || {}
  if (platform === 'tb') {
    sensors.registerPage({
      platform,
      channel: 'tb',
    })
  }
  let name = ''
  if (username === shot_name) {
    name = username
  } else {
    name = `${shot_name}:${username}`
  }
  sensors.login(name)
  window.gio?.('setUserId', name)
}

export function logoutSensors() {
  sensors.logout()
}
